export default "__VITE_ASSET__DJCaSLGQ__"